import { isUndefined } from 'lodash-es';
import * as t from 'io-ts';
import { isNotNullable } from '@bayer-int/portletce-shared';

import type { MultiSelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';
import {
    getListOfMandatorySettingOptions,
    getMandatorySettingKeyBasedOnLabel,
} from './_settingsThatCanBeMandatory';

export interface ResettableSettingsSettingDefinition extends MultiSelectDefinition {
    key: 'RESETTABLE_SETTINGS';
    type: 'MultiSelect';
}

const definition: ResettableSettingsSettingDefinition = {
    key: 'RESETTABLE_SETTINGS',
    type: 'MultiSelect',
    label: 'Resettable settings',
    value: [],
    options: [],
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.array(t.string));

export const codec = specSettingsInterface.input;

export const ResettableSettingsSettingDefinition = define({
    key: 'RESETTABLE_SETTINGS',
    label: 'resettableSettings',
    definition,
    fromSetting: settings => {
        const value = specSettingsInterface.extractValue(settings.resettableSettings);

        return isUndefined(value)
            ? undefined
            : value
                  .map(label => getMandatorySettingKeyBasedOnLabel(settings, label))
                  .filter(isNotNullable);
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        !isUndefined(settings.resettableSettings)
            ? {
                  ...definition,
                  ...specSettingsInterface.createDefinitionWithSettings(
                      settings.resettableSettings,
                  ),
                  options: getListOfMandatorySettingOptions(settings),
              }
            : undefined,
});
